/* eslint-disable */
export const api = {
  API_URL: process.env.API_URL || 'http://localhost:5001/api/',
  API_AUTH: process.env.AUTH_URL || 'http://localhost:5001/auth/',
  API_TOKEN: process.env.TOKEN_KEY || 'leoleoAuthToken',
};
/* eslint-enable */
